// pages/eventos/clientes/painel/PainelEventoCliente.jsx

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../../../../axiosConfig";
import "./PainelEventoCliente.css";

const PainelEventoCliente = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [status, setStatus] = useState(null);
  const [evento, setEvento] = useState(null);
  const [premio, setPremio] = useState(null); // ✅ novo
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(true);

  const statusLabels = {
    aguardando_aprovacao: "Aguardando conferência",
    pontos_creditados: "Pontos creditados",
    resgate_criado: "Resgate gerado",
    premio_fisico_pendente: "Prêmio físico em preparo",
    em_analise: "Em análise",
    rejeitado: "Resgate rejeitado",
    reprocessado: "Reprocessado"
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setErro("Você precisa estar logado para ver o status do evento.");
      setLoading(false);
      return;
    }

    const buscarInfo = async () => {
      try {
        const [statusRes, eventoRes, premioRes] = await Promise.all([
          axios.get(`/api/eventos/status/${slug}`, {
            headers: { Authorization: `Bearer ${token}` }
          }),
          axios.get(`/api/eventos/${slug}`),
          axios.get(`/evento/resultado/${slug}`, {
            headers: { Authorization: `Bearer ${token}` }
          })
        ]);

        setStatus(statusRes.data);
        setEvento(eventoRes.data);
        setPremio(premioRes.data?.premio || null);
      } catch (err) {
  console.error("Erro ao buscar dados do evento:", err);

  const msg = err?.response?.data?.erro?.toLowerCase?.() || "";

  if (msg.includes("token")) {
    setErro("⚠️ Sua sessão expirou. Faça login novamente.");
  } else if (msg.includes("nenhum sorteio encontrado")) {
    setErro("⚠️ Você ainda não participou deste evento.");
  } else if (msg.includes("usuário não identificado")) {
    setErro("⚠️ Não foi possível identificar seu usuário.");
  } else {
    setErro("Erro ao carregar as informações do evento.");
  }
} finally {
  setLoading(false);
}

    };

    buscarInfo();
  }, [slug]);

  if (loading) return <div className="status-loading">Carregando status...</div>;
  if (erro) return <div className="erro">{erro}</div>;

  return (
    <div className="painel-evento-status">
      <h1>{evento?.nome_evento || "Evento"}</h1>
      <p className="data-evento">
        Período:{" "}
        {evento?.data_inicio && new Date(evento.data_inicio).toLocaleDateString("pt-BR")} até{" "}
        {evento?.data_fim && new Date(evento.data_fim).toLocaleDateString("pt-BR")}
      </p>

      {status?.status && (
  <p>
    Status:{" "}
    <strong>
      {statusLabels[status.status] || status.status.replaceAll("_", " ")}
    </strong>
  </p>
)}

{status?.observacao && (
  <p className="observacao">Observação: {status.observacao}</p>
)}

{premio && (
  <div className="premio-cliente-info">
    <p className="descricao-premio">Prêmio conquistado:</p>
    <h3 className="nome-premio">
      {typeof premio === "string" ? premio : premio.nome}
    </h3>
    {typeof premio === "object" && premio.imagem && (
      <img
        src={premio.imagem}
        alt={premio.nome}
        className="imagem-premio"
      />
    )}
  </div>
)}


{!status?.status && !premio?.nome && (
  <p className="status-vazio">
    Você ainda não participou deste evento.
  </p>
)}


      <button
        onClick={() => navigate("/painel-cliente/eventos")}
        className="btn-voltar-painel"
      >
        ← Voltar para Meus Eventos
      </button>
    </div>
  );
};

export default PainelEventoCliente;
